import { createStore } from 'effector';

export const $usersLog = createStore({ count: 0, data: [] });
export const $usersLogsTableProps = createStore({
  page: 1,
  limit: 10,
  object_type: null,
  object_id: null,
  audit_action: null,
  ip_address: null,
  endpoint: null,
  user_id: null,
});

export const $usersList = createStore({ count: 0, data: [] });
export const $usersListTableProps = createStore({
  page: 1,
  limit: 10,
});

export const $userLoginHistory = createStore({ count: 0, data: [] });
export const $userLoginTableProps = createStore({
  page: 1,
  limit: 10,
  user_id: undefined,
});

export const $adminChangePassModal = createStore({ open: false, uId: null });

export const $adminCreateUserModal = createStore(false);
export const $adminBlockUserModal = createStore({ open: false, uId: null });
